export default __webpack_public_path__ + "static/Evistamp_Legal Notice v1.0-11d10f1142b605e42586ef27f9425de5.pdf";